import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBYOyuULZHXAl9rDYU7Uw9z4kWALCvagJk",
  authDomain: "kampus-companion.firebaseapp.com",
  projectId: "kampus-companion",
  storageBucket: "kampus-companion.firebasestorage.app",
  messagingSenderId: "936276079179",
  appId: "1:936276079179:web:e86432c1a4b5d1cd4893ce",
  measurementId: "G-CYZQSHRVZG"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Cloud Functions base URL - set after deploying Firebase Cloud Functions
// Example: https://us-central1-kampus-companion.cloudfunctions.net
export const CF_BASE_URL = process.env.REACT_APP_CF_BASE_URL || "https://us-central1-kampus-companion.cloudfunctions.net";

// Admin emails allowed to use the admin panel. Passwords are managed only by Firebase Auth.
export const ADMIN_EMAILS = [
  "pixelpy18@gmail.com",
  "kairox.1302@gmail.com",
  "kampuscompanion@gmail.com",
];

export const CONTROL_EMAILS = [
  "pixelpy18@gmail.com",
  "kairox.1302@gmail.com",
];

// Razorpay public key id. The secret key must stay only in Firebase Cloud Functions config.
export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || "rzp_live_Svc2gYIexZa5G3";
